import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from '../../lib/customer-validators';
import { ContactService } from 'src/app/services/contact.service';
import { Contact } from 'src/app/models/contact';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  public breadcrumbLinks=[];
  public thisPage:string='Contact';
  public image:string='/assets/imgs/contact-header.jpg';
  public title:string='Contact';
  public blurb:string='We are always here to help, you may find our FAQs helpful, but if you would like to contact us directly please fill in the form below or call us on 0207 582 1692';
  public contactForm: FormGroup;
  public contact: Contact;
  public mailTo: string = environment.contactFormRecipient;
  public sending:boolean=false;
  public sent:boolean=false;
  public sentError:boolean=false;

  constructor(
    private _contact: ContactService
  ) {
    this.contactForm = new FormGroup({
      firstName: new FormControl('',[Validators.required,CustomValidators.validateTextField]),
      lastName: new FormControl('',[Validators.required,CustomValidators.validateTextField]),
      emailAddress: new FormControl('',[Validators.required,CustomValidators.validateEmailAddress]),
      subject: new FormControl('',[Validators.required,CustomValidators.validateTextField]),
      message: new FormControl('',[Validators.required,CustomValidators.validateTextField])
    });
  }

  public resetContactForm(){
    this.contactForm.reset();
    for (var i in this.contactForm.controls) {
      this.contactForm.controls[i].markAsUntouched();
    }
  }

  public sendContact(){
    for (var i in this.contactForm.controls) {
      this.contactForm.controls[i].markAsTouched();
    }
    if(this.contactForm.valid) {
      //this.sending=true;
      this.contact = new Contact({
        firstName: this.contactForm.controls.firstName.value,
        lastName: this.contactForm.controls.lastName.value,
        emailAddress: this.contactForm.controls.emailAddress.value,
        subject: this.contactForm.controls.subject.value,
        message: this.contactForm.controls.message.value,
        to: this.mailTo
      });
      this._contact.sendMessage(this.contact).subscribe(
        (res:any) => {
          if(res.message=='validated'){
            this.sent=true;
            this.resetContactForm();
            setTimeout(()=>{
              this.sent=false;
            }, 5000);
          } else {
            this.sentError=true;
            setTimeout(()=>{
              this.sentError=false;
            }, 5000);
          }
          this.sending=false;
        }
      );
    }
  }

  ngOnInit() {
  }

}
